import { sanitizeEntryDataResponseBase } from "./commonUtils";

export const sanitizeSingleStatisticsEntryData = ({ dataResponse }) => {
  const defaultValues = {
    id: "",
    patient_owner: "",
    created: "2023-01-01T00:00:00.000000-00:00",
    date_modified: "2023-01-01T00:00:00.000000-00:00",

    affected_percentage_body: 0,
    affected_percentage_front: 0,
    affected_percentage_back: 0,
    pasi_score: 0,

    head_affected_percentage: 0,
    head_area_score: 0,
    head_segment_score: 0,
    head_erythema: 0,
    head_induration: 0,
    head_desquamation: 0,

    torso_affected_percentage: 0,
    torso_area_score: 0,
    torso_segment_score: 0,
    torso_erythema: 0,
    torso_induration: 0,
    torso_desquamation: 0,

    arms_affected_percentage: 0,
    arms_area_score: 0,
    arms_segment_score: 0,
    arms_erythema: 0,
    arms_induration: 0,
    arms_desquamation: 0,

    legs_affected_percentage: 0,
    legs_area_score: 0,
    legs_segment_score: 0,
    legs_erythema: 0,
    legs_induration: 0,
    legs_desquamation: 0,
  };

  let sanitizedResponse = sanitizeEntryDataResponseBase({
    entryDataResponse: dataResponse,
    defaultValues: defaultValues,
  });

  sanitizedResponse.created = new Date(sanitizedResponse.created);
  sanitizedResponse.date_modified = new Date(sanitizedResponse.date_modified);

  return sanitizedResponse;
};

export const sanitizePasiStatisticsEntries = ({
  statisticsEntriesResponse,
}) => {
  if (!statisticsEntriesResponse || statisticsEntriesResponse.length === 0) {
    return [];
  }

  return statisticsEntriesResponse.map((entry) => {
    let sanitizedStatisticsData = sanitizeSingleStatisticsEntryData({
      dataResponse: entry,
    });

    return sanitizedStatisticsData;
  });
};
